import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=3706a7cc&scoped=true&"
import script from "./productlist.vue?vue&type=script&lang=js&"
export * from "./productlist.vue?vue&type=script&lang=js&"
import style0 from "./productlist.vue?vue&type=style&index=0&id=3706a7cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3706a7cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3706a7cc')) {
      api.createRecord('3706a7cc', component.options)
    } else {
      api.reload('3706a7cc', component.options)
    }
    module.hot.accept("./productlist.vue?vue&type=template&id=3706a7cc&scoped=true&", function () {
      api.rerender('3706a7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/InventoryManagement/Inventory/form/add/components/productlist.vue"
export default component.exports